import { render } from "./examWaitResult.vue?vue&type=template&id=2053e396&scoped=true"
import script from "./examWaitResult.vue?vue&type=script&lang=js"
export * from "./examWaitResult.vue?vue&type=script&lang=js"

import "./examWaitResult.vue?vue&type=style&index=0&id=2053e396&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2053e396"]])

export default __exports__